import Network from './network';

export default {
  inviteUsersToChannels(callbacks, args = {}) {
    return Network.post('/channels/invite_users_as_json', args, callbacks);
  },
};
